import { useState, useEffect } from "react";
import { isMobile } from "@rio-cloud/rio-uikit/utils/deviceUtils";

import Header from "./components/header";

import Info from "./components/info";
import Tabs, { ITabOptions } from "./components/tabs";
import EditGroupSidebar from "./components/edit/edit";
import HistoryGroupSidebar from "./components/history/history";

import { Asset } from "../../models/asset";

import "./styles.scss";
export interface IContractDetailsSidebarProps {
  asset: Asset | null;
  show: boolean;
  onClose: () => void;
  onSuccess: () => void
}

const MaintenanceGroupSidebar = ({
  asset,
  show,
  onClose,
  onSuccess
}: IContractDetailsSidebarProps) => {
  const [activeTab, setActiveTab] = useState<ITabOptions>("edit");
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (show) {
      setIsClosing(false);
      setActiveTab('edit');
    }
  }, [show]);


  const handleClose = () => onClose();

  if (!show || !asset) return null;


  const closingClassBg = isClosing ? " contract-details-bg--closing" : "";
  const closingClassSidebar = isClosing ? " contract-details-sidebar--closing" : "";

  const mobile = isMobile();

  return (
    <>
      <div
        className={`contract-details-bg${closingClassBg}`}
        onClick={handleClose}
        aria-hidden
      />
      <div
        className={`contract-details-sidebar${closingClassSidebar} ${mobile ? "!w-[90%]" : "!w-[70%]"} max-w-[830px]`}
      >
        <Header onClose={handleClose} />

        <Info
          chassis={asset.chassis}
          model={asset.planInfo?.planVehicleDetails?.modelName || asset.model}
          maintenanceGroup={asset.groupName}
          licensePlate={asset.licensePlate}
          contractNumber={asset.planInfo?.contractNumber}
          contractType={asset.planInfo?.planName}
          accountName={asset.accountName}
          startAt={asset.planInfo?.startAt}
          endAt={asset.planInfo?.endAt}
          activationDate={asset.planInfo?.activationDate}
          odometer={asset.odometer}
          hourmeter={asset.hourmeter}
        />

        <Tabs
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />

        {activeTab === "edit" && (
          <EditGroupSidebar 
            group={asset?.group || '-'} 
            chassis={asset.chassis} 
            model={asset.model}
            setIsClosing={setIsClosing} 
            onSuccess={onSuccess}
          />
        )}

        {activeTab === "history" && (
          <HistoryGroupSidebar chassis={asset.chassis}  />
        )}
      </div>
    </>
  );
};

export default MaintenanceGroupSidebar;
